import { useEffect, useState } from "react";
import { Form } from "@deere/ux.uxframe-react";
import { QUESTION_TYPES, POPUP_QUESTIONS_TITLES } from "../../utils/constants";
import { getSurveyById } from "../../services/survey.service";
import { Card, CardContent, Typography, Accordion, AccordionItem, AccordionTitle, AccordionSummary, AccordionDetails } from "@deere/fuel-react";
import { CircleProgressIndicator } from "../CircleProgressIndicator";
import { CRS_SURVEY_TEMPLATES, SURVEYPART_SECTION_TYPES } from '../../utils/surveyLiterals'

const IntegrationSettings = ({ campaign, authState, selectedQues, setSelectedQues, selectedSec, setSelectedSec, loading }) => {
  const [section, setSection] = useState([]);
  useEffect(() => {
    if (campaign && campaign.surveyId) {
      getSurveyById(campaign.surveyId, authState.accessToken.accessToken)
        .then((res) => {
          if (res && res.sections && res.sections.length > 0) {
            let sections = res.sections.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).filter((sec) => sec.questions.length > 0);
            sections.forEach((sec) => (sec.questions = sec.questions.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))));
            if(campaign.templateType === CRS_SURVEY_TEMPLATES.PART){
              let authorizerSection = sections.find((sec) => sec.type === SURVEYPART_SECTION_TYPES.QUESTIONS);
              let partSections = sections.filter((sec) => sec.type === SURVEYPART_SECTION_TYPES.PART);
              let partsQuestionsArray = [];
              partSections.forEach((partSection) => {
                  let partsTableQuestions = partSection.questions.filter((que) => (!POPUP_QUESTIONS_TITLES.includes(que.type)));
                  partsQuestionsArray.push({...partSection, questions: partsTableQuestions});
              });
              partsQuestionsArray = [authorizerSection, ...partsQuestionsArray];
              setSection(partsQuestionsArray);
            }else{
              setSection(sections);
            }
            setSelectedQues([]);
            setSelectedSec([]);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [campaign.surveyId]);

  const getQuestionText = (que) => {
    let quesText = que.text ? que.text : "";
    const regexp = /<a[^>]*>([^<]*)<\/a>/g;
    if (que.html) {
      quesText = quesText.replace(regexp, "$1");
    }
    if (que.text === "" && que.type === QUESTION_TYPES.CHECK && Array.isArray(que.selections) && que.selections.length > 0) {
      quesText = que.selections[0].text;
      if (que.selections[0].html) {
        quesText = quesText.replace(regexp, "$1");
      }
    }
    return quesText;
  };

  const handleCheckboxChange = (e) => {
    if (e.target.name === "queId") {
      let value = Number(e.target.value);
      let secId = Number(e.target.getAttribute("sectionid"));
      let quesIds = [...selectedQues];
      let index = quesIds.findIndex((ps) => ps === value);
      index === -1 ? quesIds.push(value) : quesIds.splice(index, 1);
      setSelectedQues(quesIds);
      let sect = section.find((sec) => sec.id === secId);
      let allquesAvailable = true;
      sect.questions.forEach((que) => {
        if (!quesIds.includes(que.id)) allquesAvailable = false;
      });
      if (allquesAvailable && index === -1) {
        setSelectedSec((prevState) => {
          let newState = [...prevState];
          newState.push(secId);
          return newState;
        });
      } else if (!allquesAvailable && index > -1) {
        setSelectedSec((prevState) => {
          let newState = prevState.filter((ps) => ps !== secId);
          return newState;
        });
      }
    } else if (e.target.name === "secId") {
      let value = Number(e.target.value);
      let secIds = [...selectedSec];
      let index = secIds.findIndex((sec) => sec === value);
      index === -1 ? secIds.push(value) : secIds.splice(index, 1);
      setSelectedSec(secIds);
      let sectionClicked = section.find((sec) => sec.id === value);
      if (sectionClicked) {
        let queIds = sectionClicked.questions.map((que) => que.id);
        if (index === -1) {
          setSelectedQues((prevState) => {
            queIds.forEach((qid) => {
              if (!prevState.includes(qid)) prevState.push(qid);
            });
            return prevState;
          });
        } else {
          setSelectedQues((prevState) => {
            queIds.forEach((qid) => {
              let idx = prevState.findIndex((ps) => ps === qid);
              if (idx > -1) prevState.splice(idx, 1);
            });
            return prevState;
          });
        }
      }
    }
  };

  return (
    <Card borderRadius="sm">
      <CardContent>
        <Typography className="mt-2 mb-3" variant="h2">
          Survey Questions for integration
        </Typography>
        {section.length > 0 ? (
          <Accordion variant="elevated">
            {section.map((sec) => {
              return (
                <AccordionItem defaultExpanded key={sec?.id}>
                  <AccordionSummary rightAligned>
                    <AccordionTitle>{sec?.description}</AccordionTitle>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Form.Check
                      label={<strong>Select All</strong>}
                      value={sec?.id}
                      onChange={(e) => handleCheckboxChange(e)}
                      checked={selectedSec.includes(sec?.id)}
                      name="secId"
                      size="lg"
                      className={"ml-2"}
                      disabled={loading}
                    />
                    {sec?.questions?.map((que) => (
                      <Form.Check
                        key={que.id}
                        label={getQuestionText(que)}
                        value={que.id}
                        onChange={(e) => handleCheckboxChange(e)}
                        checked={selectedQues.includes(que.id)}
                        name="queId"
                        size="lg"
                        className={"ml-2"}
                        sectionid={sec?.id}
                        disabled={loading}
                      />
                    ))}
                  </AccordionDetails>
                </AccordionItem>
              );
            })}
          </Accordion>
        ) : (
          <CircleProgressIndicator title="Waiting for Survey selection." subtitle="Please select a survey type from the top section in order to see the questions." />
        )}
      </CardContent>
    </Card>
  );
};

export default IntegrationSettings;
